import base64urlSafe from "@/frontend/lib/base64urlSafe";

export default function (clientId: string, scopes: string, state: object, showBypass: string | null = null, stateId: string | null = null) {
    const script = document.createElement("script");
    script.setAttribute("id", "oneid-button");
    script.setAttribute("src", process.env.MIX_ONEID_WIDGET_SCRIPT as string);
    script.setAttribute("data-target", process.env.MIX_API_BASE_URL + "/oidc");
    script.setAttribute("data-product", "age_verification");
    script.setAttribute("data-environment", "production");
    script.setAttribute("data-client-id", clientId);
    stateId ? script.setAttribute("data-state", stateId) : script.setAttribute("data-state", base64urlSafe(JSON.stringify(state)));
    script.setAttribute("data-scope", scopes);
    showBypass && script.setAttribute("data-show-bypass", showBypass);

    return script;
}
